import { generateMSNAvatar } from '../utils/uiUtils';
import type { Channel } from '../core/resolvers/EntityResolver';
import type { ChatContact, Message } from '../types/chat';

export const DEFAULT_CHANNELS: Channel[] = [
  { id: 'general', name: 'General', type: 'text', position: 0 },
  { id: 'music', name: 'Music', type: 'text', position: 1 },
  { id: 'media', name: 'Media', type: 'text', position: 2 },
  { id: 'memes', name: 'Memes', type: 'text', position: 3 },
  { id: 'misc', name: 'Misc.', type: 'text', position: 4 },
  { id: 'vc', name: 'Voice Channel', type: 'voice', position: 5 }
];

export const CONTACTS: ChatContact[] = [
  {
    id: 'glitch',
    name: 'GlitchGamer',
    avatar: generateMSNAvatar('Felix'),
    status: 'Is the server live?',
    type: 'human',
    secure: true,
    isOnline: true,
    bio: 'Security researcher and low-level enthusiast. I break things so you don\'t have to.',
    joinDate: 'Oct 2023',
    location: 'Berlin, DE'
  },
  {
    id: 'synth',
    name: 'SynthRider',
    avatar: generateMSNAvatar('Aneka'),
    status: 'Check out this emote.',
    type: 'human',
    secure: false,
    isOnline: true,
    bio: 'Electronic music producer and visual artist. Living in the neon lights.',
    joinDate: 'Jan 2024',
    location: 'Tokyo, JP'
  }
];

export const INITIAL_MESSAGES: Record<string, Message[]> = {
  'glitch': [
    { id: '1', text: "Yo! I just noticed there's zero telemetry on this platform. My sniffer isn't picking up any outbound pings.", time: "09:42 AM", type: 'received', reactions: {} },
    { id: '2', text: "Messages expire in 8 hours", time: "", type: 'system', reactions: {} },
    { id: '3', text: "Exactly as intended. We don't sell data because we don't even collect it.", time: "09:44 AM", type: 'sent', reactions: {} }
  ],
  'synth': [
     { id: '1', text: "Hey, check out this new track I made.", time: "10:00 AM", type: 'received', reactions: {} }
  ],
  'gemini': [
     { id: '1', text: "Hello! How can I help you today?", time: "Now", type: 'received', reactions: {} }
  ],
  'gpt': [],
  'claude': []
};

export const SOUNDBOARD_SOUNDS = [
  { id: 'airhorn', name: 'Airhorn', icon: '📣', url: 'https://www.myinstants.com/media/sounds/mlg-air-horn.mp3' },
  { id: 'crickets', name: 'Crickets', icon: '🦗', url: 'https://www.myinstants.com/media/sounds/crickets.mp3' },
  { id: 'laugh', name: 'Laugh', icon: '😂', url: 'https://www.myinstants.com/media/sounds/laugh.mp3' },
  { id: 'fart', name: 'Fart', icon: '💨', url: 'https://www.myinstants.com/media/sounds/fart.mp3' },
  { id: 'wow', name: 'Wow', icon: '😮', url: 'https://www.myinstants.com/media/sounds/wow.mp3' },
  { id: 'yeet', name: 'Yeet', icon: '🚀', url: 'https://www.myinstants.com/media/sounds/yeet.mp3' },
];
